<template>
  <div >
    <a-back-top />
    <a-row>
      <a-col :md="24">
        <div class="allbody" :style="{transform : `scale(${scaleW},${scaleH})`}">
<!--          <div style="float: left;margin-top: 1%;margin-left: 10%">
            <img src="~@/assets/imgs/logo1.png" width="40">
          </div>-->
          <div style="margin-top: 1%;float: right;margin-right: 15%;">
            <router-link to='/'><a>首页</a></router-link>
            <router-link to='/productintr'><a>产品介绍</a></router-link>
            <router-link to='/aboutus'><a>关于我们</a></router-link>
            <router-link to='/caseinfo'><a style="font-weight: bold;">业绩案例</a></router-link>
            <router-link to='/contantus'><a-button shape="round">联系我们</a-button></router-link>
          </div>
          <div class="contant">
            <p style="color: rgba(255, 255, 255, 100);font-size: 38px;font-weight: bold">
              <span>智能管理 智慧决策</span>
            </p>
            <p style="color: rgba(255, 255, 255, 100);font-size: 16px;">
              <span> 公司围绕镜面云码、电梯中台、电梯物联网<br/>
                设备、气瓶充装管理系统、特种设备检验检测信息化平台<br/>
                等方向持续开展研发与服务，面向城市安全与公共服务场景<br/>提供相关技术支持
              </span>
            </p>
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;margin-top: 5%;margin-bottom: 5%;">
          <div>
            <p style="color: #222A41;font-size: 20px;font-weight: bold;">电梯公共服务平台</p>
            <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23% 1% 23%">面向企业与管理方，支持电梯维保信息登记、检测信息登记、按需维保申请、
              信息公示等功能
            </div>
          </div>
          <img src="~@/assets/imgs/elevpt.png" style="height:400px;">
          <div style="width: 80px;height:80px;background-color: rgba(59, 67, 242, 100);border-radius: 50%;margin: 0 auto;margin-bottom: 5%;"> </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;margin-bottom: 5%;">
          <div>
            <p style="color: #222A41;font-size: 20px;font-weight: bold;">特种设备数据中台</p>
            <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23% 1% 23%">
              面向业务系统与开发者，提供特种设备基础数据、分析结果数据及 API 接口能力，支持应用的创建、维护、发布与监控等生命周期管理
            </div>
            <img src="~@/assets/imgs/ztpt.png" style="height:400px;">
            <div style="width: 80px;height:80px;background-color: rgba(59, 67, 242, 100);border-radius: 50%;margin: 0 auto;margin-bottom: 5%;"> </div>
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;margin-bottom: 5%;">
          <div>
            <p style="color: #222A41;font-size: 20px;font-weight: bold;">特种设备安全码综合管理平台</p>
            <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23% 1% 23%">
              平台面向管理端和企业端，支持特种设备安全码赋码、码管理及相关服务应用
            </div>
            <img src="~@/assets/imgs/tmmpt.png" style="height:400px;">
            <div style="width: 80px;height:80px;background-color: rgba(59, 67, 242, 100);border-radius: 50%;margin: 0 auto;margin-bottom: 5%;"> </div>
          </div>
        </div>
      </a-col>
<!--      <a-col :md="24">
        <div style="text-align: center;margin-bottom: 5%;">
          <div>
            <p style="color: #222A41;font-size: 20px;font-weight: bold;">电梯保险服务管理系统</p>
            <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23% 1% 23%">
              平台面向保险管理端、维保端和使用单位端，支持相关业务协同与电梯运行服务管理
            </div>
            <img src="~@/assets/imgs/bxpt.png" style="height:400px;margin-bottom: 20px;">
          </div>
        </div>
      </a-col>-->
      <a-col :md="24">
        <div style="text-align: center;margin-bottom: 5%">
          <a-button type="primary" shape="round"><router-link to='/contantus'>了解更多</router-link></a-button>
        </div>
      </a-col>
      <a-col :md="24">
        <foot-boot1 />
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import footBoot1 from './footboot1'
  export default {
    name: 'Website',
    components: {
      footBoot1
    },
    data () {
      return {
        scaleW: 1,
        scaleH: 1,
        size:50,
        tabBarGutter:100
      }
    },
    created(){

    },
    methods: {
      callback(key) {
        console.log(key);
      },
    }
  }
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  a{
    white-space: nowrap;
    color: black;
    font-family: SourceHanSansSC-regular;
    margin-right: 5%;
  }
  a:hover{
    color: black;
    font-weight: bold;
  }
  .allbody{
    width: 100%;
    transform-origin: left top;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  .allbody img{
    width: 140px;
    height: 30px;
  }
  .contant{
    height: 300px;
    background-color: #3B43F2;
    margin-top: 4%;
    text-align: center;
    padding-top: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Caseinfo.vue